import type { AgentTool } from '@saaga/shared/interfaces/agent-tool.interface'
import { Trash2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

export interface ToolListItemProps {
  tool: AgentTool
  onRemove: (toolId: string) => void
  isDisabled?: boolean
}

/**
 * Single tool item displayed as a list row with name, description and remove button.
 * Shows bold tool name with helper text description below.
 */
export const ToolListItem = ({
  tool,
  onRemove,
  isDisabled = false,
}: ToolListItemProps): ReactNode => {
  const handleRemove = (): void => {
    onRemove(tool.id)
  }

  return (
    <div className="tool-list-item flex items-start justify-between gap-3 rounded-md border bg-muted/30 p-3">
      <div className="min-w-0 flex-1">
        <p className="tool-list-item-name font-medium leading-tight">{tool.name}</p>
        <p className="tool-list-item-description mt-0.5 text-sm text-muted-foreground">
          {tool.description}
        </p>
      </div>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="tool-list-item-remove size-8 shrink-0 text-muted-foreground hover:bg-destructive hover:text-destructive-foreground"
        onClick={handleRemove}
        disabled={isDisabled}
      >
        <Trash2Icon className="size-4" />
        <span className="sr-only">Remove {tool.name}</span>
      </Button>
    </div>
  )
}

ToolListItem.displayName = 'ToolListItem'
